module.exports = __webpack_public_path__ + "img/nft-factory.cff721e4.png";